__turbopack_context__.v({
  "canvasContainer": "HeroSection-module__pkYU_W__canvasContainer",
  "comingDisclaimer": "HeroSection-module__pkYU_W__comingDisclaimer",
  "ctaContainer": "HeroSection-module__pkYU_W__ctaContainer",
  "mainContent": "HeroSection-module__pkYU_W__mainContent",
  "root": "HeroSection-module__pkYU_W__root",
});
